<template>
  <div class="stars">
    <img
      src="@/assets/images/icon_star_active.png"
      v-for="n in score"
      :key="`active-${n}`"
      alt=""
      class="star"
    />
    <img
      src="@/assets/images/icon_star.png"
      v-for="n in remain"
      :key="`unactive-${n}`"
      class="star"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
      default: 5
    },
    score: {
      type: Number,
      default: 0
    }
  },
  computed: {
    remain() {
      return this.max - this.score;
    }
  }
};
</script>
<style lang="scss" scoped>
.stars {
  white-space: nowrap;
  .star {
    margin-right: 0.5rem;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
